import React from "react";
import { allStatuses } from "../OrderList";

export default function EsimMenu({ order, mobile, setCancel, setDetail }) {
  const isVisible = (type) => {
    switch (type) {
      case "View Order":
        return Boolean(order?._id);
      case "Cancel Booking":
        return (
          allStatuses?.includes(order?.status) &&
          !["Cancelled", "Canceled"].includes(order?.status)
        );
      default:
        return false;
    }
  };

  const menu = [
    {
      label: "View Order",
      action: () => {
        setDetail?.(true);
      },
      visible: isVisible("View Order"),
    },
    {
      label: "Cancel Booking",
      action: () => {
        setCancel?.(true);
      },
      visible: isVisible("Cancel Booking"),
    },
  ];

  return (
    <div
      className={`${
        !mobile ? "absolute right-2 top-full" : ""
      } p-2 flex flex-col z-10 bg-white rounded-md shadow-xl min-w-[200px]`}
    >
      {menu
        ?.filter((item) => item?.visible)
        ?.map((item, index) => (
          <div
            key={index}
            className="w-full cursor-pointer text-sm text-black py-1 px-2 transition-all hover:text-primary1"
            onClick={item.action}
          >
            <span>{item.label}</span>
          </div>
        ))}
    </div>
  );
}
